export default {
  familyName: 'Nunito Sans',
  fullName: 'Nunito Sans 12pt ExtraLight',
  postscriptName: 'NunitoSans12pt-ExtraLight',
  category: 'sans-serif',
  capHeight: 705,
  ascent: 1011,
  descent: -353,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 484,
  xWidthAvg: 436,
  subsets: {
    latin: {
      xWidthAvg: 436
    },
    thai: {
      xWidthAvg: 500
    }
  }
};
